import DefaultLayout from './DefaultLayout.container';

export default DefaultLayout;
